import store from "../../store";

export const ifAuthenticated = async (to, from, next) => {
  if (store.getters["user/isUserLogged"] !== null) {
    next();
  } else if (store.getters["user/haveTokens"] !== null) {
    await store.dispatch("user/fetchUserInfo");
    if (store.getters["user/isUserLogged"] !== null) {
      next();
    }
  } else {
    next({ name: "Login", query: { redirect_to: to.fullPath } });
  }
};
